/**
 * Components
 */
import inverterForm from './inverterForm';
import pvModuleForm from './pvModuleForm';
import Tooltip from '@/components/Tooltip';

export default {
    props: ['csrftoken', 'product'],

    data() {
        return {
            isActive: false,
        };
    },

    components: {
        inverterForm,
        pvModuleForm,
        Tooltip
    },

    computed: {
        classObject() {
            return {
                'favourite-product': true,
                [`favourite-product--${this.product.type}`]: true,
                'favourite-product--active': this.isActive,
                'favourite-product--expired': this.isExpired,
            };
        },

        form() {
            return `${this.product.type}Form`;
        },

        isExpired() {
            return !!this.product.expired;
        }
    },

    template: `
        <div :class="classObject">
            <div class="favourite-product__row">
                <div class="favourite-product__type">
                    <span></span>
                    <p class="h6 favourite-product__typename">{{ product.type }}</p>
                </div>
                <div class="favourite-product__name">
                    <p class="h6 text--grey-light">{{ product.manufacturer }}</p>
                    <p class="h4">{{ product.model }}</p>
                </div>

                <div class="favourite-product__icons">
                    <div class="favourite-product__invalid">
                        <Tooltip v-if="!product.valid" text="This product does not contain all the required data points. Please fill out all required fields">
                            <svg><use xlink:href="#alert" /></svg>
                        </Tooltip>
                    </div>
                    <button v-if="!isExpired" class="favourite-product__toggle" @click="isActive = !isActive"></button>
                </div>
            </div>

            <component
                v-if="!isExpired"
                :is="form"
                :type="product.type"
                :csrftoken="csrftoken"
                :ownerid="product.ownerId"
                :companyid="product.companyId"
                :salesforceid="product.salesforceId"
                :details="product.details"
                :expiry="product.expiry"
                :valid="Boolean(product.valid)"
                :errors="product.errors"
                class="favourite-product__content"
            />
        </div>
    `,
};
